import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSquareArrowUpRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 14",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 0c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0zM5 3.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h2.94L3.72 9.219a.75.75 0 0 0 1.06 1.06l4.218-4.22L9 9.25c0 .416.334.75.75.75s.75-.334.75-.75v-5a.75.75 0 0 0-.75-.75z" })
});
export default SvgIconSquareArrowUpRight;
